import { render, staticRenderFns } from "./list.vue?vue&type=template&id=70131e18&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=70131e18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70131e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70131e18')) {
      api.createRecord('70131e18', component.options)
    } else {
      api.reload('70131e18', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=70131e18&scoped=true", function () {
      api.rerender('70131e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/welfare/list.vue"
export default component.exports